var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderToolbarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 21,
    viewBox: "0 0 73 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5539 0.0883789H63.7373L72.0488 20.9116H66.6568L64.9885 16.6219H57.3027L55.6344 20.9116H50.2126L58.5539 0.0883789ZM63.6778 12.5704L61.1456 5.56975L58.5837 12.5704H63.6778Z",
    fill: "#0C162A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8696 0.0883789H39.3469C41.6308 0.0883789 43.6268 0.50544 45.3347 1.33956C47.0427 2.17368 48.3535 3.37522 49.267 4.94416C50.2005 6.49325 50.6672 8.31044 50.6672 10.3957C50.6672 13.8514 49.6543 16.4729 47.6286 18.2603C45.6029 20.0279 42.7927 20.9116 39.198 20.9116H31.8696V0.0883789ZM39.6448 16.4729C41.4521 16.4729 42.8324 15.9268 43.7857 14.8345C44.7588 13.7422 45.2454 12.2626 45.2454 10.3957C45.2454 8.68778 44.7588 7.28765 43.7857 6.19534C42.8324 5.08318 41.5117 4.5271 39.8236 4.5271H37.1425V16.4729H39.6448Z",
    fill: "#0C162A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9275 0.0883789H29.2003V20.9116H23.9275V0.0883789Z",
    fill: "#0C162A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34122 0.0883789H13.5247L21.8361 20.9116H16.4441L14.7759 16.6219H7.09004L5.42179 20.9116H0L8.34122 0.0883789ZM13.4651 12.5704L10.933 5.56975L8.37101 12.5704H13.4651Z",
    fill: "#0C162A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderToolbarLogo);
export default __webpack_public_path__ + "static/media/HeaderToolbarLogo.afe0b5f43f90fba1f180abb789502988.svg";
export { ForwardRef as ReactComponent };